@if (loading()) {
    <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/75 p-16">
        <vds-turbine-spinner class="text-gray-800" [style.--vds-spinner-size]="'128px'" />
    </div>
}
<router-outlet />
